// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_66f14eb","eventName":"_33f4606","starSubIcon":"_9ab1768","iconWrapper":"_d460807","eventInfoWrapper":"_cd37ac9"};